<template>
  <div class="custom-field-value text-truncate" style="max-width: 250px;" :title="title">
    <slot />
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { Nullable } from '@/utils/types';

// Keeps a long custom field value on one line in the list row; the full value shows on hover.
export default defineComponent({
  name: 'CustomFieldCell',

  props: {
    // The row's custom field value, shown as the tooltip. Null when the record has none.
    title: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null,
    },
  },
});
</script>
